var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckmarkGreen = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.165 7.337a.75.75 0 1 0-.997 1.121zm3.194 3.843-.498.56a.75.75 0 0 0 1.11-.127zm7.586-9.413A.75.75 0 0 0 11.721.9zM1.168 8.458l3.693 3.282.996-1.121-3.692-3.282zm4.803 3.155 6.974-9.846L11.721.9l-6.974 9.846z"
})));
export default SvgCheckmarkGreen;